import React, { useCallback, useState } from 'react';
import { NoColorLink } from 'ui/NoColorLink';
import { IconButton, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { HR_HOME_PAGE_URL } from 'components/App/components/routes';
import EditIcon from '@mui/icons-material/Edit';
import Flex from 'ui/Flex/Flex';
import RetrospectiveModal from 'routes/HumanResourcesModule/Retrospective/RetrospectiveHome/RetrospectiveModal/RetrospectiveModal';
import { usePatchRetrospective } from 'routes/HumanResourcesModule/Retrospective/helpers/hooks/retrospective';
import {
    PatchRetrospectivePayload,
    RetrospectiveT,
} from 'routes/HumanResourcesModule/Retrospective/helpers/types';
import OrgChartChips from 'routes/HumanResourcesModule/components/OrgChartChips';

const SynthesisHeaderWrapper = (props: { children: React.ReactNode }) => {
    return (
        <Flex
            alignItems="center"
            gap="2em 0"
            padding="2em 0 1em 0"
            width="100%"
        >
            {props.children}
        </Flex>
    );
};
type Props = {
    retrospective: RetrospectiveT;
};
function SynthesisHeader({ retrospective }: Props): React.ReactElement<[]> {
    const [showRetrospectiveModal, setShowRetrospectiveModal] = useState(false);
    const updateRetrospectiveMutation = usePatchRetrospective();
    const {
        isPending: isUpdateRetrospectiveLoading,
        isError: isUpdateRetrospectiveError,
    } = updateRetrospectiveMutation;

    const toggleRetrospectiveModal = useCallback(() => {
        setShowRetrospectiveModal((current) => !current);
    }, []);

    const onSave = ({ title }: PatchRetrospectivePayload) => {
        updateRetrospectiveMutation.mutate({
            id: retrospective.id,
            title,
        });
    };
    return (
        <SynthesisHeaderWrapper>
            <Flex alignItems="left" direction="column" sx={{ width: '100%' }}>
                <Flex alignItems="center" marginBottom="1rem">
                    <NoColorLink to={`${HR_HOME_PAGE_URL}/retrospective_home`}>
                        <IconButton sx={{ padding: 0 }}>
                            <ArrowBackIosIcon fontSize="small" />
                        </IconButton>
                    </NoColorLink>
                    <Typography variant="h4" sx={{ display: 'flex' }}>
                        {`${retrospective.exercice} - ${retrospective.title}`}
                    </Typography>
                    <IconButton
                        onClick={toggleRetrospectiveModal}
                        onMouseDown={(e) => e.stopPropagation()}
                    >
                        <EditIcon />
                    </IconButton>
                </Flex>
                <OrgChartChips item={retrospective} />
            </Flex>
            {showRetrospectiveModal && (
                <RetrospectiveModal
                    onSave={onSave}
                    show={showRetrospectiveModal}
                    editMode
                    onClose={toggleRetrospectiveModal}
                    isError={isUpdateRetrospectiveError}
                    retrospective={retrospective}
                    isLoading={isUpdateRetrospectiveLoading}
                />
            )}
        </SynthesisHeaderWrapper>
    );
}

export default SynthesisHeader;
